import { useStats } from '../ctx/stats'
import { MonthlyBookStat, RatingStat, StreakStatResult } from '../../types'
import { getStatsAuthors } from '../utils'

type StatType = 'authors' | 'ratings' | 'streaks' | 'genres' | 'mom-books-read'

const getStatResultsEmpty = (stats: any, key: StatType) => {
  switch (key) {
    case 'authors':
      return getStatsAuthors(stats)
    case 'ratings':
      return stats?.ratings?.results
        ?.map((r: RatingStat) => r.count !== 0)
        .filter(Boolean)
    case 'streaks':
      return stats?.streaks?.results
        ?.map((s: StreakStatResult) => s.count !== 0)
        .filter(Boolean)
    case 'genres':
      return stats?.genres?.results
    case 'mom-books-read':
      return stats?.mom_books_read?.results
        ?.map((r: MonthlyBookStat) => r.count !== 0)
        .filter(Boolean)
    default:
      return []
  }
}

export const useStatsZeroState = (type: StatType) => {
  const stats = useStats((s) => s.stats)
  return !getStatResultsEmpty(stats, type)?.length
}

export const useStatsAllZeroState = () => {
  const stats = useStats((s) => s.stats)

  if (!stats) return true

  return Object.keys(stats).every(
    (key) => !getStatResultsEmpty(stats, key as StatType)?.length
  )
}
